module.exports = __webpack_public_path__ + "static/media/unlimitedGamesPlayed_10000_50000.8395c841.png";